import { nodeConfig } from '@scripts/mixins';

const NAMESPACE = 'cookie-notice';
const DEFAULT_SELECTOR = '[data-js-cookie-notice]';
const DEFAULT_SETTINGS = {};

/**
 * Google consent mode cookie notice.
 */
class CookieNotice {
	/**
	 * @param {HTMLElement} node
	 * @param {Object} config
	 */
	constructor(node, config) {
		this.elNode = node;
		this.config = config;
		this.elAcceptButton = this.elNode.querySelector('[data-js-cookie-notice-button="accept"]');
		this.elRejectButton = this.elNode.querySelector('[data-js-cookie-notice-button="reject"]');
	}

	init() {
		try {
			if (localStorage.getItem('consentMode') !== null) return;
		} catch {
			return;
		}

		this._show();
		this._bindUI();
	}

	_show() {
		this.elNode.classList.add('cookie-notice--visible');
		this.elNode.removeAttribute('inert');
	}

	_hide() {
		this.elNode.classList.remove('cookie-notice--visible');
		this.elNode.setAttribute('inert', '');
	}

	_setConsent(consent) {
		if (typeof window.gtag !== 'function') return;

		const consentMode = {
			ad_storage: consent.marketing ? 'granted' : 'denied',
			ad_user_data: consent.marketing ? 'granted' : 'denied',
			ad_personalization: consent.marketing ? 'granted' : 'denied',
			analytics_storage: consent.analytics ? 'granted' : 'denied',
			functionality_storage: consent.necessary ? 'granted' : 'denied',
			personalization_storage: consent.preferences ? 'granted' : 'denied',
			security_storage: consent.necessary ? 'granted' : 'denied'
		};

		gtag('consent', 'update', consentMode);

		try {
			localStorage.setItem('consentMode', JSON.stringify(consentMode));
		} catch {
			// Storage unavailable (private browsing, quota exceeded)
		}
	}

	_bindUI() {
		this._onAcceptClick = this._onAcceptClick.bind(this);
		this._onRejectClick = this._onRejectClick.bind(this);

		this.elAcceptButton?.addEventListener('click', this._onAcceptClick);
		this.elRejectButton?.addEventListener('click', this._onRejectClick);
	}

	_onAcceptClick() {
		this._setConsent({
			necessary: true,
			analytics: true,
			preferences: true,
			marketing: true
		});

		this._hide();
	}

	_onRejectClick() {
		this._setConsent({
			necessary: true,
			analytics: false,
			preferences: false,
			marketing: false
		});

		this._hide();
	}
}

export default function factory(selector = DEFAULT_SELECTOR, settings = {}) {
	const listNode = document.querySelectorAll(selector);

	if (!listNode.length) return;

	return Array.from(listNode).map((node) => {
		const config = nodeConfig(node, NAMESPACE, settings, DEFAULT_SETTINGS);
		const module = new CookieNotice(node, config);

		module.init();

		return module;
	});
}
